module.exports = __webpack_public_path__ + "static/bearvelour2-26895f7d97857fa6f4247bf358ea8b8b.png";